export const getUserMenus = /* GraphQL */ `
  query GetUser(
    $loginName: String!
    $tenant: String!
    $landscape: String!
    $limit: Int
    $nextToken: String
  ) {
    getUser(loginName: $loginName, tenant: $tenant, landscape: $landscape) {
      menus(limit: $limit, nextToken: $nextToken) {
        items {
          menuId
          product
          parentMenuId
          menuNames {
            items {
              language
              name
              menuId
            }
          }
          menuDescriptions {
            items {
              language
              description
              menuId
            }
          }
          url
          isCategory
          accessedTimeStamp
          sort
          menuIconFont
          canUseFromExtra
        }
        nextToken
      }
    }
  }
`;

export const getUsersByTenantLandscape = /* GraphQL */ `
  query UserByTenantLandscape(
    $tenant: String
    $landscape: ModelStringKeyConditionInput
    $nextToken: String
    $limit: Int
  ) {
    userByTenantLandscape(
      tenant: $tenant
      landscape: $landscape
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        loginName
        isAdmin
        roleId
      }
      nextToken
    }
  }
`;

export const getLoginUserAllInfo = /* GraphQL */ `
  query GetLoginUserAllInfo(
    $loginName: String!
    $tenant: String!
    $landscape: String!
    $favoriteTenantLandscape: ModelFavoriteUserFavoritesCompositeKeyConditionInput
    $tenantLandscapeLoginName: String
    $accessedTimeStamp: ModelIntKeyConditionInput
    $displayStartDate: ModelIntKeyConditionInput
  ) {
    loginUser: getUser(
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
    ) {
      name
      affiliation
      displaysFavoritePanel
      isAdmin
      language
      csrSchema
      cwsSchema
      cjkSchema
      ctmSchema
    }
    favoriteMenus: userFavorites(
      loginName: $loginName
      tenantLandscape: $favoriteTenantLandscape
    ) {
      items {
        menuId
        sort
      }
    }
    historyMenus: menuByAccessedTimeStamp(
      tenantLandscapeLoginName: $tenantLandscapeLoginName
      accessedTimeStamp: $accessedTimeStamp
      sortDirection: DESC
      limit: 10
    ) {
      items {
        menuId
      }
    }
    cwsNotification: getNotice(
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
    ) {
      html
    }
    cwsEvent: getEvent(
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
    ) {
      html
    }
    userAnnouncements: userAnnouncementsByDisplayStartDate(
      tenantLandscapeLoginName: $tenantLandscapeLoginName
      displayStartDate: $displayStartDate
      sortDirection: DESC
    ) {
      items {
        announcementId
        loginName
        tenant
        landscape
        tenantLandscapeLoginName
        announcement {
          title
          content
          linkToProductMenu
          isPublic
          priorityTag
        }
        displayStartDate
        displayEndDate
        isProcessed
        isRead
        isShow
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getLoginUserAllInfoWithoutAnnouncement = /* GraphQL */ `
  query GetLoginUserAllInfoWithoutAnnouncement(
    $loginName: String!
    $tenant: String!
    $landscape: String!
    $favoriteTenantLandscape: ModelFavoriteUserFavoritesCompositeKeyConditionInput
    $tenantLandscapeLoginName: String
    $accessedTimeStamp: ModelIntKeyConditionInput
  ) {
    loginUser: getUser(
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
    ) {
      name
      affiliation
      displaysFavoritePanel
      isAdmin
      language
      csrSchema
      cwsSchema
      cjkSchema
      ctmSchema
    }
    favoriteMenus: userFavorites(
      loginName: $loginName
      tenantLandscape: $favoriteTenantLandscape
    ) {
      items {
        menuId
        sort
      }
    }
    historyMenus: menuByAccessedTimeStamp(
      tenantLandscapeLoginName: $tenantLandscapeLoginName
      accessedTimeStamp: $accessedTimeStamp
      sortDirection: DESC
      limit: 10
    ) {
      items {
        menuId
      }
    }
  }
`;

export const getLoginUserAllInfoWithoutCWS = /* GraphQL */ `
  query GetLoginUserAllInfoWithoutCWS(
    $loginName: String!
    $tenant: String!
    $landscape: String!
    $favoriteTenantLandscape: ModelFavoriteUserFavoritesCompositeKeyConditionInput
    $tenantLandscapeLoginName: String
    $accessedTimeStamp: ModelIntKeyConditionInput
    $displayStartDate: ModelIntKeyConditionInput
  ) {
    loginUser: getUser(
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
    ) {
      name
      affiliation
      displaysFavoritePanel
      isAdmin
      language
      csrSchema
      cwsSchema
      cjkSchema
      ctmSchema
    }
    favoriteMenus: userFavorites(
      loginName: $loginName
      tenantLandscape: $favoriteTenantLandscape
    ) {
      items {
        menuId
        sort
      }
    }
    historyMenus: menuByAccessedTimeStamp(
      tenantLandscapeLoginName: $tenantLandscapeLoginName
      accessedTimeStamp: $accessedTimeStamp
      sortDirection: DESC
      limit: 10
    ) {
      items {
        menuId
      }
    }
    userAnnouncements: userAnnouncementsByDisplayStartDate(
      tenantLandscapeLoginName: $tenantLandscapeLoginName
      displayStartDate: $displayStartDate
      sortDirection: DESC
    ) {
      items {
        announcementId
        loginName
        tenant
        landscape
        tenantLandscapeLoginName
        announcement {
          title
          content
          linkToProductMenu
          isPublic
          priorityTag
        }
        displayStartDate
        displayEndDate
        isProcessed
        isRead
        isShow
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getLoginUserInfo = /* GraphQL */ `
  query GetLoginUserInfo(
    $loginName: String!
    $tenant: String!
    $landscape: String!
  ) {
    loginUser: getUser(
      loginName: $loginName
      tenant: $tenant
      landscape: $landscape
    ) {
      name
      affiliation
      displaysFavoritePanel
      isAdmin
      language
      csrSchema
      cwsSchema
      cjkSchema
      ctmSchema
    }
  }
`;
